import { hideModal, openModal } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

const selectors = {
  MODAL_PRODUCT_BIS_SELECTOR: 'modal-product-bis',
  MINI_CART_SELECTOR: 'MiniCart'
}

function ButtonBIS({ product, currentVariant, buttonText, classButton }) {
  const handleClick = () => {
    globalEmitter.emit(emitterProps.product.openModalBIS, {
      currentVariant,
      product
    })

    hideModal(selectors.MINI_CART_SELECTOR)
    openModal(selectors.MODAL_PRODUCT_BIS_SELECTOR)
  }

  return (
    <button type="button" aria-label={buttonText} className={classButton} onClick={handleClick}>
      {buttonText}
    </button>
  )
}

export default ButtonBIS
